import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

export let startBatchPaymentForm = () => {
  const root = createRoot(document.getElementById('batch_payments_app'))
  root.render(<App />)
}
